



import { Component, Vue, Prop } from 'vue-property-decorator'
import QuizAttempt from '../../api/quizAttempt'
import getApi from '@/api'
import { QuestionInterface, UserAnswerInterface } from '@/interface/BaseInterface'
import { forEach, find, assign } from 'lodash'

const quizAttempt: QuizAttempt = getApi('quizAttempt')

@Component({ components: {} })
export default class AttemptResult extends Vue {
  @Prop({ required: true, type: Array }) listQuestion!: QuestionInterface[]
  @Prop({ required: true, type: String }) propAttemptId!: string

  attemptResult: UserAnswerInterface[] = []
  isLoading = false

  result: any[] = []

  async init() {
    try {
      this.isLoading = true
      this.attemptResult = await quizAttempt.attemptDetail(this.quizId, this.propAttemptId)
      this.getResult()
      this.isLoading = false
    } catch (error) {
      this.isLoading = false
      console.log(error)
    }
  }

  getResult() {
    const result: any[] = []
    forEach(this.listQuestion, value => {
      const a = find(this.attemptResult, elm => {
        return elm.questionId === value._id
      })
      if (a) {
        result.push(assign(value, a))
      } else {
        result.push(value)
      }
    })
    this.result = result
  }

  created() {
    this.init()
  }
}
